import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { HeaderComponent } from './blocks/header/header.component';
import { FooterComponent } from './blocks/footer/footer.component';
import {
  LocationStrategy,
  HashLocationStrategy,
  PathLocationStrategy,
} from '@angular/common';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { PaymentComponent } from './payment/payment.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PortfolioComponent } from './portfolio/portfolio.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { CallBackComponent } from './call-back/call-back.component';
import { GalleryComponent } from './gallery/gallery.component';
import { ConsultNowModalComponent } from './models/consult-now/button/consult-now-modal.component';
import { EcosystemComponent } from './blocks/ecosystem/ecosystem.component';
import { GlobalPresenceComponent } from './blocks/global-presence/global-presence.component';
import { StrengthComponent } from './blocks/strength/strength.component';
import { ValuesComponent } from './blocks/values/values.component';
import { ServicesComponent } from './blocks/services/services.component';
import { TechComponent } from './blocks/tech/tech.component';
import { TeamComponent } from './blocks/team/team.component';
import { LeadersComponent } from './blocks/leaders/leaders.component';
import { ReviewsComponent } from './blocks/reviews/reviews.component';
import { ContactComponent } from './blocks/contact/contact.component';
import { AiSolutionsComponent } from './blocks/ai-solutions/ai-solutions.component';
import { AiFeatureCardComponent } from './blocks/ai-solutions/ai-feature-card.component';
import { DialogContentConsultDialog } from './models/consult-now/page/consult-content';
import { DialogContentContactBTNDialog } from './models/Contact-btn/page/contact-btn';
import { FloatingWhatsappComponent } from './floating-whatsapp/floating-whatsapp.component';
import { MatNativeDateModule } from '@angular/material/core';
import { GalleryComponentModel } from './models/gallery/gallery.component';
import { LoadingSpinner } from './models/Spinner/spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TrustBtnModalComponent } from './models/Contact-btn copy/button/trusted.component';
import { TrustedBTNDialog } from './models/Contact-btn copy/page/trusted';
import { OurProductsComponent } from './our-products/our-products.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { SharedModule } from './shared/shared.module';
import { CommonserviceComponent } from './commonservice/commonservice.component';
import { UserReviewComponent } from './user-review/user-review.component';
import { InternshipComponent } from './internship/internship.component';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { CountingNumberComponent } from "./counting-number/counting-number.component";
import { ContractualServiceComponent } from './contractual-service/contractual-service.component';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';
import { ToastrModule } from 'ngx-toastr';
import { LoaderComponent } from './loader/loader.component';
import { NgxMaterialIntlTelInputComponent } from 'ngx-material-intl-tel-input';
import { ServicesMegaMenuComponent } from './blocks/header/services-mega-menu/services-mega-menu.component';
import { MoreMegaMenuComponent } from './blocks/header/more-mega-menu/more-mega-menu.component';
@NgModule({ 
    declarations: [
        AppComponent,
        HomeComponent,
        HeaderComponent,
        ServicesMegaMenuComponent,
        FooterComponent,
        PaymentComponent,
        PortfolioComponent,
        ContactUsComponent,
        AboutUsComponent,
        CallBackComponent,
        ConsultNowModalComponent,
        AiSolutionsComponent,
        AiFeatureCardComponent,
        DialogContentConsultDialog,
        GalleryComponent,
        DialogContentContactBTNDialog,
        GalleryComponentModel,
        FloatingWhatsappComponent,
        LoadingSpinner,
        TrustBtnModalComponent,
        TrustedBTNDialog,
        OurProductsComponent,
        ProductDetailsComponent,
        CommonserviceComponent,
        UserReviewComponent,
        InternshipComponent,
        ContractualServiceComponent,
        LoaderComponent
    ],
      schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent], 
    imports: [BrowserModule,
        AppRoutingModule,
        SlickCarouselModule,
        FormsModule,
        BrowserAnimationsModule,
        EcosystemComponent,
        GlobalPresenceComponent,
        StrengthComponent,
        ValuesComponent,
        ServicesComponent,
        TechComponent,
        TeamComponent,
        LeadersComponent,
        ReviewsComponent,
        ContactComponent,
        MatTabsModule,
        SharedModule,
        MatDialogModule,
        ReactiveFormsModule,
        MatNativeDateModule,
        MatProgressBarModule,
        MatSnackBarModule,
        CountingNumberComponent,
        MoreMegaMenuComponent,
        NgxMaterialIntlTelInputComponent,
        AngularFireModule.initializeApp(environment.firebaseConfig),
        AngularFireDatabaseModule,
        ToastrModule.forRoot({
            positionClass: 'toast-top-right',
            timeOut: 3000,
            preventDuplicates: true
        })], 
        providers: [
              provideClientHydration(),
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        // {
        //   provide: HTTP_INTERCEPTORS,
        //   useClass: ApiInterceptor,
        //   multi : true
        // },
        provideLottieOptions({
            player: () => player,
        }),
        provideHttpClient(withInterceptorsFromDi()),
       
    ] })
export class AppModule {}
